import { ChangeEvent } from 'react';
import { Stack } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import Button from 'components/_core/Button';
import * as Form from 'components/_core/form';
import SunshineModal from 'components/_core/SunshineModal';
import { isValidEmail } from 'components/LegacyInput/utils';

import locales from './locales';
import * as S from './styles';
import { ClientContact } from './types';

interface ClientContactFormProps {
  clientContact: ClientContact;
  loading?: boolean;
  modalTitle: string;
  submitButtonText: string;
  onHeaderBack?: () => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
}

const ClientContactForm: FCWithChildren<ClientContactFormProps> = ({
  children,
  clientContact,
  loading,
  modalTitle,
  onChange,
  onHeaderBack,
  onSubmit,
  submitButtonText,
}) => {
  const { email, firstName, lastName, phone } = clientContact;
  const isSubmitButtonDisabled =
    !firstName || !lastName || !isValidEmail(email);

  return (
    <>
      <SunshineModal.Header>
        <SunshineModal.Header.IconButton
          icon="arrow-left"
          onClick={onHeaderBack}
        />
      </SunshineModal.Header>

      <SunshineModal.Body>
        <S.PhoneBookImage />

        <SunshineModal.Title>{modalTitle}</SunshineModal.Title>

        <Stack spacing="space-24">
          <Form.Field label={locales.firstName}>
            <Form.Input
              defaultValue={firstName}
              name="firstName"
              onChange={onChange}
              placeholder={locales.firstName}
              type="text"
            />
          </Form.Field>

          <Form.Field label={locales.lastName}>
            <Form.Input
              defaultValue={lastName}
              name="lastName"
              onChange={onChange}
              placeholder={locales.lastName}
              type="text"
            />
          </Form.Field>

          <Form.Field label={locales.email}>
            <Form.Input
              defaultValue={email}
              name="email"
              onChange={onChange}
              placeholder={locales.email}
              type="text"
            />
          </Form.Field>

          <Form.Field label={locales.phone}>
            <Form.Input
              defaultValue={phone}
              name="phone"
              onChange={onChange}
              placeholder={locales.phone}
              type="text"
            />
          </Form.Field>
        </Stack>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        {children}

        <Button
          icon="arrow-right"
          isDisabled={isSubmitButtonDisabled}
          isLoading={loading}
          onClick={onSubmit}
          type="submit"
        >
          {submitButtonText}
        </Button>
      </SunshineModal.Footer>
    </>
  );
};

export default ClientContactForm;
